export const siteInfo = {
  name: '里番动漫精选',
  tagline: '探索里番动漫的精彩世界',
  description: '里番动漫精选推荐与观看指南，为您提供热门的里番动漫作品推荐、分类浏览、观看渠道介绍及相关资讯，帮助成人动漫爱好者快速找到优质里番动漫内容。',
  founded: '2020',
  email: 'contact@example.com',
  phone: '400-000-0000',
  address: '中国上海市浦东新区',
  socialLinks: {
    weibo: 'https://weibo.com',
    bilibili: 'https://bilibili.com',
    zhihu: 'https://zhihu.com',
  },
  stats: {
    totalArticles: 1280,
    totalCategories: 26,
    totalUsers: 58000,
    totalReviews: 9600,
  },
  testimonials: [
    {
      name: '动漫爱好者小王',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20person%2C%20simple%20warm%20background%2C%20friendly%20expression%2C%20clean%20digital%20art%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
      comment: '这个网站是我发现优质里番动漫的首选平台！分类清晰，推荐精准，每次都能找到合口味的作品。内容深度也很棒，不是简单的推荐列表，而是有深度的分析和点评。',
      rating: 5,
    },
    {
      name: '资深动漫评论人老张',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20mature%20person%2C%20professional%20look%2C%20simple%20warm%20background%2C%20clean%20digital%20art%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
      comment: '作为一名从事动漫评论多年的从业者，我对这个网站的专业性表示认可。文章内容有深度，分类体系科学，是难得的优质里番动漫资讯平台。',
      rating: 5,
    },
    {
      name: '新入坑的动漫迷小陈',
      avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20enthusiastic%20person%2C%20simple%20warm%20background%2C%20excited%20expression%2C%20clean%20digital%20art%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
      comment: '刚开始接触里番动漫的时候一头雾水，多亏了这个网站的入门指南和分类推荐，让我快速找到了自己喜欢的作品类型。推荐给所有想入坑的朋友！',
      rating: 4,
    },
  ],
  faqs: [
    {
      question: '什么是里番动漫？',
      answer: '里番动漫是日本动漫文化中的一个特定分类，源自日语词汇，指面向成人观众的动画作品。这类作品通常包含较为成熟的主题内容和表现手法，有着独立的制作体系和发行渠道。',
    },
    {
      question: '如何选择适合自己的里番动漫？',
      answer: '建议先从我们的分类浏览入手，根据自己的兴趣偏好选择题材类型。对于新手，推荐从评分较高、口碑较好的经典作品开始观看，逐步培养自己的审美偏好。',
    },
    {
      question: '里番动漫的观看渠道有哪些？',
      answer: '里番动漫可以通过正规的流媒体平台、DVD/蓝光碟片以及部分授权网站观看。我们建议通过正规渠道支持创作者，确保获得最佳的观看体验。',
    },
    {
      question: '里番动漫和普通动漫有什么区别？',
      answer: '主要区别在于目标受众和内容定位。里番动漫面向成人观众，在主题深度和表现手法上更加成熟。普通动漫则面向全年龄段，内容更加大众化。两者在制作标准、发行渠道等方面也存在差异。',
    },
    {
      question: '这个网站的推荐是如何产生的？',
      answer: '我们的推荐综合了专业评审打分、平台用户评分以及观众投票数据。同时，我们的编辑团队会持续关注行业动态，确保推荐内容的时效性和专业性。',
    },
  ],
};